import { css } from '@emotion/react';

import { Spacing } from 'chatie-design-system';

import { safeArea } from '../../styles/css';
import Frame from './Frame';

const coverImageCSS = css`
  padding-bottom: 62.5%;
  ${safeArea('top')};
`;

const infoCSS = css`
  padding: ${Spacing.medium}px;

  div:nth-of-type(1) {
    width: 50%;
    height: 16px;
    margin-top: ${Spacing.medium}px;
  }

  div:nth-of-type(2) {
    width: 90%;
    height: 16px;
    margin-top: ${Spacing.medium}px;
  }

  div:nth-of-type(3) {
    width: 85%;
    height: 16px;
    margin-top: ${Spacing.medium}px;
  }

  div:nth-of-type(4) {
    width: 60%;
    height: 16px;
    margin-top: ${Spacing.xlarge}px;
  }

  div:nth-of-type(5) {
    width: 80%;
    height: 16px;
    margin-top: ${Spacing.medium}px;
  }

  div:nth-of-type(6) {
    width: 40%;
    height: 16px;
    margin-top: ${Spacing.medium}px;
  }
`;

const StoryDetailSkeleton = () => {
  return (
    <>
      <Frame css={coverImageCSS} />

      <div css={infoCSS}>
        <Frame />
        <Frame />
        <Frame />
        <Frame />
        <Frame />
        <Frame />
      </div>
    </>
  );
};

export default StoryDetailSkeleton;
